import React, { createContext, useState } from "react";

export const EvaluationContext = createContext();

export const EvaluationProvider = ({ children }) => {
  const [evaluationData, setEvaluationData] = useState(null);
  const [pendingEvaluations, setPendingEvaluations] = useState([]);
  const [completedEvaluations, setCompletedEvaluations] = useState([]);

  const moveApplicantToCompleted = ({
    applicationId,
    status = "Completed",
    fallbackApplicant = {},
  }) => {
    if (!applicationId && !fallbackApplicant?.ApplicationId) return;
    const rawApplicationId =
      applicationId !== undefined && applicationId !== null && applicationId !== ""
        ? applicationId
        : fallbackApplicant?.ApplicationId;
    const normalizedApplicationId =
      rawApplicationId !== undefined && rawApplicationId !== null
        ? String(rawApplicationId)
        : "";
    const fallbackApplicationNumber =
      fallbackApplicant?.["Application Number"] ??
      fallbackApplicant?.applicationNumber ??
      "";
    const normalizedFallbackNumber =
      fallbackApplicationNumber !== undefined &&
      fallbackApplicationNumber !== null
        ? String(fallbackApplicationNumber)
        : "";

    let movedApplicant = null;
    setPendingEvaluations((prev = []) =>
      prev.filter((applicant = {}) => {
        const applicantId =
          applicant?.ApplicationId ??
          applicant?.applicationId ??
          applicant?.["ApplicationId"] ??
          null;
        const applicantNumber =
          applicant?.["Application Number"] ??
          applicant?.applicationNumber ??
          applicant?.ApplicationNumber ??
          null;
        const normalizedApplicantId =
          applicantId !== undefined && applicantId !== null
            ? String(applicantId)
            : "";
        const normalizedApplicantNumber =
          applicantNumber !== undefined && applicantNumber !== null
            ? String(applicantNumber)
            : "";
        const matches =
          (normalizedApplicationId &&
            normalizedApplicantId === normalizedApplicationId) ||
          (!normalizedApplicantId &&
            normalizedApplicationId &&
            normalizedApplicantNumber === normalizedApplicationId) ||
          (normalizedFallbackNumber &&
            normalizedApplicantNumber === normalizedFallbackNumber);
        if (matches) {
          movedApplicant = applicant;
        }
        return !matches;
      })
    );

    const baseApplicant = movedApplicant || fallbackApplicant;
    if (!baseApplicant) return;

    const normalizedStatus =
      status === "Absent" ? "Absent" : "Evaluation accepted";
    const isAbsent = status === "Absent";

    const updatedApplicant = {
      ...baseApplicant,
      ApplicationId: normalizedApplicationId || baseApplicant?.ApplicationId,
      Status: normalizedStatus,
      Scoresheet: isAbsent ? "-" : "View",
      "Mark Absent": isAbsent,
    };

    setCompletedEvaluations((prev) => {
      const filtered = prev.filter(
        (applicant) =>
          String(applicant.ApplicationId ?? "") !== normalizedApplicationId
      );
      return [...filtered, updatedApplicant];
    });
  };

  return (
    <EvaluationContext.Provider
      value={{
        evaluationData,
        setEvaluationData,
        pendingEvaluations,
        setPendingEvaluations,
        completedEvaluations,
        setCompletedEvaluations,
        moveApplicantToCompleted,
      }}
    >
      {children}
    </EvaluationContext.Provider>
  );
};